import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/client';
import ConfirmDialog from '../common/ConfirmDialog';

export default function AdvertiserList() {
  const [advertisers, setAdvertisers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmItem, setConfirmItem] = useState(null);

  useEffect(() => {
    fetchAdvertisers();
  }, [search]);

  const fetchAdvertisers = async () => {
    setLoading(true);
    try {
      const params = search ? { search } : {};
      const { data } = await api.get('/api/advertisers', { params });
      setAdvertisers(data);
    } catch (err) {
      console.error('[AdvertiserList] Failed to fetch:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!confirmItem) return;
    try {
      await api.delete(`/api/advertisers/${confirmItem.id}`);
      setAdvertisers(advertisers.filter((a) => a.id !== confirmItem.id));
    } catch (err) {
      console.error('[AdvertiserList] Delete failed:', err);
    } finally {
      setConfirmOpen(false);
      setConfirmItem(null);
    }
  };

  if (loading) {
    return (
      <div className="flex min-h-[300px] items-center justify-center">
        <p className="text-dark-400">Loading advertisers...</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-dark-100">Advertisers</h1>
        <Link to="/advertising/advertisers/create" className="btn btn-primary btn-sm">
          + New Advertiser
        </Link>
      </div>

      <input
        type="text"
        placeholder="Search advertisers..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="input max-w-sm"
      />

      {advertisers.length === 0 ? (
        <div className="py-12 text-center text-dark-400">No advertisers found. Create your first advertiser.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Contact</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Campaigns</th>
                <th className="text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {advertisers.map((adv) => (
                <tr key={adv.id}>
                  <td className="font-medium text-dark-100">
                    <Link to={`/advertising/advertisers/${adv.id}/edit`} className="hover:text-primary-400">
                      {adv.name}
                    </Link>
                  </td>
                  <td className="text-dark-300">{adv.contact_name || '—'}</td>
                  <td className="text-sm text-dark-300">{adv.email || '—'}</td>
                  <td className="text-sm text-dark-300">{adv.phone || '—'}</td>
                  <td className="text-dark-300">{adv.campaign_count || 0}</td>
                  <td className="text-right">
                    <Link
                      to={`/advertising/advertisers/${adv.id}/edit`}
                      className="text-xs text-dark-400 hover:text-dark-200 mr-1"
                      title="Edit"
                    >
                      ✎
                    </Link>
                    <button
                      onClick={() => {
                        setConfirmItem(adv);
                        setConfirmOpen(true);
                      }}
                      className="text-xs text-error-400 hover:text-error-300"
                      title="Delete"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <ConfirmDialog
        open={confirmOpen}
        title="Delete Advertiser"
        message={`Are you sure you want to delete "${confirmItem?.name}"? Associated campaigns may be affected.`}
        danger
        onConfirm={handleDelete}
        onClose={() => setConfirmOpen(false)}
      />
    </div>
  );
}
